/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { ApiClient } from '../types/api/ApiClient';
import { EntityId } from '../types/api/EntityId';
import { SUDatasetCategory } from '../types/superuser/dataset-category/SUDatasetCategory';
import { SUDatasetCategoryCreateRequest } from '../types/superuser/dataset-category/SUDatasetCategoryCreateRequest';
import { SUDatasetCategoryUpdateRequest } from '../types/superuser/dataset-category/SUDatasetCategoryUpdateRequest';
import { getApiEndpoint } from '../utils/getApiEndpoint';
import { apiClientFactory } from '../utils/http-client/apiClientFactory';
import { axiosInstanceFactory } from '../utils/http-client/axiosInstanceFactory';
import { axiosJwtTokenInterceptor, axiosUnauthorizedInterceptor } from '../utils/http-client/axiosInterceptors';

class SuperuserDatasetCategoryApiServiceClass {
  private api: ApiClient;

  constructor() {
    this.api = apiClientFactory(
      axiosInstanceFactory(
        { baseURL: getApiEndpoint() },
        [axiosJwtTokenInterceptor],
        [[undefined, axiosUnauthorizedInterceptor]],
      ),
    );
  }

  fetchDatasetsCategories = () => this.api.get<SUDatasetCategory[]>(`/administration/dataset-category`);

  createDatasetCategory = ({ data }: { data: SUDatasetCategoryCreateRequest }) => {
    return this.api.post<SUDatasetCategoryCreateRequest>('/administration/dataset-category', data);
  };

  updateDatasetCategory = ({
    datasetCategoryId,
    data,
  }: {
    datasetCategoryId: EntityId;
    data: SUDatasetCategoryUpdateRequest;
  }) => {
    return this.api.patch<SUDatasetCategoryUpdateRequest>(
      `/administration/dataset-category/${datasetCategoryId}`,
      data,
    );
  };

  deleteDatasetCategory = ({ datasetCategoryId }: { datasetCategoryId: EntityId }) => {
    return this.api.del(`/administration/dataset-category/${datasetCategoryId}`);
  };
}

export const SuperuserDatasetCategoryApiService = new SuperuserDatasetCategoryApiServiceClass();
